import {Component, input, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

export interface SortEvent {
    field: string;
    direction: 'asc' | 'desc';
}

@Component({
    selector: '[appTableHeaderColumn]',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    template: `
        <div class="d-flex align-items-center justify-content-between" [class]="getClasses()" (click)="onSort()" [style.width]="width()">
            <div [class]="getContentClasses()">
                <ng-content></ng-content>
                @if (labelKey()) {
                    <span [style.text-align]="textAlign()">
                       {{ labelKey() | translate }}
                    </span>
                }
            </div>

            @if (sortField()) {
                <div class="sort-icon-container ms-2">
                    <i [class]="getSortIconClass()"></i>
                    <!--<i class="ti ti-chevron-up"></i>
                    <i class="ti ti-chevron-down"></i>-->
                </div>
            }
        </div>
    `,
    styles: [`
        th {
            user-select: none;
            position: relative;
        }

        th[data-sortable="true"] {
            cursor: pointer;
            transition: background-color 0.2s ease;
        }

        th[data-sortable="true"]:hover {
            background-color: var(--bs-gray-100, #f8f9fa);
        }

        .sort-icon-container {
            display: flex;
            align-items: center;
            min-width: 16px;
            height: 16px;
        }

        .sort-icon {
            font-size: 14px;
            color: #6c757d;
            transition: color 0.2s ease;
        }
    `]
})
export class AppTableHeaderColumnComponent {
    labelKey = input('');
    sortField = input('');
    currentSort = input<any[]>([]);
    width = input('');
    textAlign = input<'left' | 'center' | 'right'>('left');
    cssClass = input('');

    sortChange = output<SortEvent>()

    onSort(): void {
        if (!this.sortField()) return;

        const currentDirection = this.getCurrentDirection();
        const newDirection: 'asc' | 'desc' = currentDirection === 'asc' ? 'desc' : 'asc';

        this.sortChange.emit({
            field: this.sortField(),
            direction: newDirection
        });
    }

    private getCurrentDirection(): 'asc' | 'desc' | null {
        if (!this.sortField() || !this.currentSort()) return null;
        const sortState = this.currentSort().find(s => s.field === this.sortField());
        return sortState?.direction || null;
    }

    getSortIconClass(): string {
        const direction = this.getCurrentDirection();
        const baseClass = 'sort-icon ti';

        if (direction === 'asc') {
            return `${baseClass} ti-caret-up txt-primary`;
        } else if (direction === 'desc') {
            return `${baseClass} ti-caret-down txt-primary`;
        } else {
            return `${baseClass} ti-caret-up-down txt-dark`;
        }
    }

    getClasses(): string {
        const classes = [];

        if (this.textAlign() === 'center') classes.push('text-center');
        if (this.textAlign() === 'right') classes.push('text-end');
        if (!!this.sortField()) classes.push('cursor-pointer')
        if (this.cssClass()) classes.push(this.cssClass());

        return classes.join(' ');
    }

    getContentClasses(): string {
        const classes = ['column-content'];

        if (this.textAlign() === 'center') classes.push('text-center');
        if (this.textAlign() === 'right') classes.push('text-end');

        return classes.join(' ');
    }
}
